import React, { Dispatch, FC, SetStateAction, useState, useEffect } from "react"
import { MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/24/outline"
import { Modal } from "@/components/general/Modal"
import { Role, Search, Stats } from "@/lib/types"
import { useMutation } from "react-query"
import { api } from "@/lib/api"
import { LocalStorage } from "@/lib/types/LocalStorage"
import { Localstorage } from "@/lib/services"
import { Dropdown, SearchUser } from "@/components/general/Dropdown"

type Props = {
  title: string
  icon: any
  role: Role
  salesRepId: string
  setId: Dispatch<SetStateAction<string>>
  setStat: Dispatch<SetStateAction<Stats>>
  slug: string
}

export const SearchPopup: FC<Props> = (props) => {
  const [userPopup, setUserPopup] = useState(false)
  const [onSelectUser, setOnSelectUser] = useState<SearchUser | null>(null)
  const [userName, setUserName] = useState<string>("Any")
  const [companyName, setCompanyName] = useState<string>("Any")
  const user = Localstorage.get<LocalStorage>("next.user")
  const [search, setSearch] = useState({
    input: "",
    userRole: props.role,
    salesRepID: props.salesRepId,
  })

  const mutation = useMutation((payload: Search) =>
    api.AdminApi.Search(payload),
  )
  const mutationCustomer = useMutation((payload: Search) =>
    api.AdminApi.Search(payload),
  )

  useEffect(() => {
    if (props.role === "SALESREP") {
      mutation.mutate({
        input: "",
        userRole: "SALESREP",
        salesRepID: "",
      })
    } else {
      mutationCustomer.mutate({
        input: "",
        userRole: "CUSTOMER",
        salesRepID: "",
      })
    }
  }, [props.role, props.salesRepId])

  useEffect(() => {
    if (user?.role === "SALESREP" && props.title !== "Customer") {
      setUserName(user?.firstName || "Any")
      // setCompanyName(user?.companyName)
    }
  }, [user?.role, props.title, user?.firstName])
 
  useEffect(() => {
    setSearch((prevStats) => ({
      ...prevStats,
      salesRepID: props.salesRepId,
    }))
  }, [props.salesRepId])

  const populateData = (id: string, name: string) => {
    props.setId(id)
    props.setStat((prevStats) => ({
      ...prevStats,
      [props.slug]: id,
    }))
    setUserName(name || "Any")
  }

  const handleSelect = (id: string, name: string) => {
    if (onSelectUser?.id === id) {
      setOnSelectUser(null)
      populateData("", "")
    } else {
      setOnSelectUser({ id: id } as SearchUser)
      populateData(id, name)
    }
  }

  return (
    <>
      <Modal
        close={() => {
          setUserPopup(false)
          mutation.mutate({
            input: "",
            userRole: "SALESREP",
            salesRepID: "",
          })
          mutationCustomer.mutate({
            input: "",
            userRole: "CUSTOMER",
            salesRepID: "",
          })
        }}
        open={userPopup}
        width="small"
        title={`${props.role === "SALESREP" ? "Sales Rep" : "Customers"}`}
      >
        {props.role === "SALESREP" ? (
          <div className="">
            <Dropdown
              isCheck={true}
              isSalesRep={true}
              firstname={true}
              search={search}
              handleSearch={(input) => mutation.mutate(input)}
              listingOfUsers={
                mutation.data == undefined
                  ? null
                  : mutation.data.topMatchingUsers
              }
              selectedUser={onSelectUser as SearchUser}
              setSelectedUser={
                setOnSelectUser as Dispatch<
                  SetStateAction<SearchUser | undefined>
                >
              }
              handleSelect={handleSelect}
              populateData={populateData}
            />
          </div>
        ) : props.role === "CUSTOMER" ? (
          <div className="">
            <Dropdown
              isCheck={true}
              isSalesRep={false}
              search={search}
              firstname={true}
              handleSearch={(input) => mutationCustomer.mutate(input)}
              listingOfUsers={
                mutationCustomer.data == undefined
                  ? null
                  : mutationCustomer.data.topMatchingUsers
              }
              selectedUser={onSelectUser as SearchUser}
              setSelectedUser={
                setOnSelectUser as Dispatch<
                  SetStateAction<SearchUser | undefined>
                >
              }
              handleSelect={handleSelect}
              populateData={populateData}
            />
          </div>
        ) : (
          <></>
        )}
      </Modal>
      <div className="lg:pt-7">
        <div className="flex items-center gap-x-2">
          <props.icon className="w-5 h-5 dark:text-primary-12 text-light-1" />
          <h1 className="text-lg dark:text-primary-10 text-light-2">
            {props.title}
          </h1>
        </div>
        <div className="flex justify-start">
          <button
            className="bg-transparent outline-none dark:text-primary-11 text-light-1 text-sm pt-1 w-20"
            disabled={user?.role === "SALESREP" && props.title !== "Customer"}
            onClick={() => setUserPopup(true)}
          >
            {userName}
          </button>
          {/* <span>{user?.companyName}</span> */}
        </div>
      </div>
    </>
  )
}
